module.exports = __webpack_public_path__ + "static/media/ArrowFullWhite.d9db963f.svg";